import React, { useEffect, useState } from "react";

import services from "../../services";

import { Row, Tree, Divider } from "antd";

import { DownOutlined } from "@ant-design/icons";

import favoritoSvg from "../../assets/icons/coracaoMenu.svg";
import relogioSvg from "../../assets/icons/relogio.svg";
import lixeiraSvg from "../../assets/icons/lixeiraMenuNovo.svg";
import iconLinksCompartilhadosSvg from "../../assets/icons/clipsMenu.svg";
import iconPastasCompartilhadasSvg from "../../assets/icons/compartilharPastaMenuNovo.svg";
import "./styles.scss";
import RowDragInDrop from "../Table/RowDragInDrop";
import { listarPastas } from "../../services/http/pastaService";
import { trackPromise } from "react-promise-tracker";
import { ReactComponent as PastaFechadaSvg } from "../../assets/icons/pastaFechadaMenu.svg";
import { ReactComponent as PastaSvg } from "../../assets/icons/pasta-menu.svg";
import { ReactComponent as PastaFechadaSvgSelecionado } from "../../assets/icons/pastaFechadaMenuSelecionado.svg";
import { ReactComponent as PastaSvgSelecionado } from "../../assets/icons/pasta-menu-selecionado.svg";
import lang from "../../assets/idioma/idiomas";
const { DirectoryTree } = Tree;

const MenuGaleriaMidia = ({
  pastaSelecionada,
  onLoadData,
  treeData,
  listaDeFavoritos,
  listarLixeira,
  listarLinksCompartilhados,
  showTreeData,
  listarPastasCompartilhadas,
  handleListarAtividadeRecentes,
  menuSelecionado,
  pastaExpandida,
  expandedKeys,
  selectedKeys,
  itensSelecionados,
  setItensSelecionados,
  atualizarPastasDragInDrop,
  IdUser,
  itemsSelecionadosMover,
  setDataSource,
  setOrdenacao,
  setSelectedKeys,
}) => {
  const { IsAdmin } = services.storage.getUser();
  const [idPa, setIdPa] = useState("");

  function handleDrop(e) {}

  const pesquisarPastasArquivos = () => {
    trackPromise(
      listarPastas(IdUser, 1, 9999)
        .then((res) => {
          if (!res.fail && res.data) {
            setDataSource(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const elementos = document.querySelectorAll(".pegarId");
  elementos.forEach(function (elemento) {
    elemento.addEventListener("drop", (e) => {
      e.preventDefault();
      const texto = elemento.id ? elemento.id : null;

      services.storage.set("IDPASTA", texto);
    });
  });

  const renderizarIcone = (props) => {
    const { isLeaf, expanded, selected } = props;

    let iconeAberto = <PastaFechadaSvg />;
    let iconeFechado = <PastaSvg />;

    if (selected) {
      iconeAberto = <PastaFechadaSvgSelecionado />;
      iconeFechado = <PastaSvgSelecionado />;
    }

    const icone = isLeaf ? null : expanded ? iconeAberto : iconeFechado;

    return icone;
  };

  return (
    <div style={{ marginTop: -40 }}>
      {/* <Row>
        <span className="titulo-menu mt-2"> {lang.Galeria_de_Midia_M}</span>
      </Row> */}
      {showTreeData && (
        <div className="row row-menu-pastas ">
          <RowDragInDrop
            data={treeData}
            setItensSelecionados={setItensSelecionados}
            idPa={idPa}
            itensSelecionados={itensSelecionados}
            itemsSelecionadosMover={itemsSelecionadosMover}
            atualizarPastasDragInDrop={atualizarPastasDragInDrop}
          >
            <div
              className={`larguraArvore ${
                selectedKeys.includes("0/NuvemArquivo") ? "" : "mb-arvore"
              }`}
            >
              <DirectoryTree
                className="lista-pastas-minhaArvore"
                onExpand={pastaExpandida}
                onSelect={pastaSelecionada}
                switcherIcon={<DownOutlined />}
                loadData={onLoadData}
                treeData={treeData}
                expandedKeys={expandedKeys}
                selectedKeys={selectedKeys}
                icon={renderizarIcone}
              />
            </div>
          </RowDragInDrop>
        </div>
      )}

      {IsAdmin.toLocaleLowerCase() == "true" && (
        <>
          <div className="linhaDivisao"></div>
          <div
            className={`row galeria-menu-item ${
              menuSelecionado == 1 ? "menu-selecionado" : ""
            }`}
          >
            <img src={relogioSvg} className="menu-lateral-icon" />
            <a
              className="menu-opcao"
              href="#"
              onClick={() => {
                handleListarAtividadeRecentes(1, 10);
                setSelectedKeys([]);
              }}
            >
              <b>{lang.Atividades_Recentes}</b>
            </a>
          </div>
        </>
      )}
      <div className="linhaDivisao"></div>
      <div
        className={`row galeria-menu-item ${
          menuSelecionado == 2 ? "menu-selecionado" : ""
        }`}
      >
        <img src={favoritoSvg} className="menu-lateral-icon" />
        <a
          className="menu-opcao"
          href="#"
          onClick={() => {
            listaDeFavoritos();
            setSelectedKeys([]);
            setOrdenacao("tipo asc, nomeOrdenacao asc");
          }}
        >
          <b>{lang.Favoritos}</b>
        </a>
      </div>
      <div className="linhaDivisao"></div>
      {IsAdmin.toLocaleLowerCase() == "true" ? (
        <div
          className={`row galeria-menu-item ${
            menuSelecionado == 3 ? "menu-selecionado" : ""
          }`}
        >
          <img src={lixeiraSvg} className="menu-lateral-icon" />
          <a
            className="menu-opcaoLixeira"
            href="#"
            onClick={() => {
              listarLixeira(1);
              setSelectedKeys([]);
            }}
          >
            <b>{lang.Lixeira}</b>
          </a>
        </div>
      ) : null}
      <br />
      <br />
      <div className="row">
        <b className="titulo-menu">{lang.Itens_Cometilhados.toUpperCase()} </b>
      </div>
      <br />
      <br />
      <div
        className={`row galeria-menu-item ${
          menuSelecionado == 4 ? "menu-selecionado" : ""
        }`}
      >
        <img src={iconLinksCompartilhadosSvg} className="menu-lateral-icon" />
        <a
          className="menu-opcao"
          href="#"
          onClick={() => {
            listarLinksCompartilhados(1, null);
            setSelectedKeys([]);
          }}
        >
          <b>{lang.Links}</b>
        </a>
      </div>
      <div className="linhaDivisao"></div>
      <div
        className={`row galeria-menu-item ${
          menuSelecionado == 5 ? "menu-selecionado" : ""
        }`}
      >
        <img src={iconPastasCompartilhadasSvg} className="menu-lateral-icon" />
        <a
          className="menu-opcao"
          href="#"
          onClick={() => {
            listarPastasCompartilhadas(1, 10);
            setSelectedKeys([]);
          }}
        >
          <b>{lang.Pastas_Compartilhadas}</b>
        </a>
      </div>
    </div>
  );
};

export default MenuGaleriaMidia;
